import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=2e381f02&scoped=true"
import script from "./tips.vue?vue&type=script&lang=js"
export * from "./tips.vue?vue&type=script&lang=js"
import style0 from "./tips.vue?vue&type=style&index=0&id=2e381f02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e381f02",
  null
  
)

export default component.exports